import i18n from '@shared/i18n/i18n';

// Inglés con día primero, igual que las cabeceras de Activity («19 Aug 2026»).
const portalDateLocale = (): string => (i18n.language?.toLowerCase().startsWith('en') ? 'en-GB' : 'es-ES');

// Fecha no parseable: se muestra el texto recibido en vez de «Invalid Date».
const invalidDateFallback = (date: Date | string): string => (typeof date === 'string' ? date : '-');

export const formatDate = (date: Date | string | null | undefined): string => {
  if (!date) return '-';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return invalidDateFallback(date);
  return dateObj.toLocaleDateString(portalDateLocale(), { year: 'numeric', month: '2-digit', day: '2-digit' });
};

export const formatDateTime = (date: Date | string, options?: Intl.DateTimeFormatOptions): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (isNaN(dateObj.getTime())) return invalidDateFallback(date);
  const defaultOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  };
  return dateObj.toLocaleString(portalDateLocale(), { ...defaultOptions, ...options });
};

export const formatDateWithTime = (date: Date | string): string => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  };
  return dateObj.toLocaleString(portalDateLocale(), options);
};

/** Mismo formato visual que fecha en cabeceras (ej. «08 oct 2025») sin hora. */
export const formatDateShortMonthEs = (date: Date | string | null | undefined): string => {
  if (!date) return '-';
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  if (Number.isNaN(dateObj.getTime())) return '-';
  return dateObj.toLocaleDateString(portalDateLocale(), {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

export const capitalize = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const truncate = (str: string, length: number): string => {
  return str.length > length ? str.slice(0, length) + '...' : str;
};

export const formatBoolean = (value: boolean, trueText = 'Sí', falseText = 'No'): string => {
  return value ? trueText : falseText;
};
